import { useContext, useEffect } from "react";
import { DRAFT_ACTIONS } from "../../../components/draft/draftReducer";
import DraftDispatchContext from "../../../contexts/draftDispatchContext";
import useGetter from "../useGetter";
import useQueriesAreLoading from "../useQueriesAreLoading";
import useDraftId from "./useDraftId";

export default function useDraft() {
  const draftDispatch = useContext(DraftDispatchContext);
  const draftId = useDraftId();

  const { data: draftData, query: draftQuery } = useGetter(
    `/drafts/${draftId}`,
    { enabled: !!draftId, staleTime: 60 * 60 * 1000 }
  );

  const isLoading = useQueriesAreLoading([draftQuery]) || !draftData;

  let hasStarted = false;
  let hasEnded = false;
  let isPaused = false;
  if (!isLoading) {
    hasStarted = !!draftData.draft.actualStartDate;
    hasEnded = !!draftData.draft.endDate;
    isPaused = draftData.draft.isPaused;
  }

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: { propName: "hasStarted", value: hasStarted },
    });
  }, [hasStarted, draftDispatch]);

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: { propName: "hasEnded", value: hasEnded },
    });
  }, [hasEnded, draftDispatch]);

  useEffect(() => {
    draftDispatch({
      type: DRAFT_ACTIONS.SET_INFO,
      payload: { propName: "isPaused", value: isPaused },
    });
  }, [isPaused, draftDispatch]);

  return { draftData, draftQuery };
}
